import TextSymbol from '@arcgis/core/symbols/TextSymbol';
import LabelClass from '@arcgis/core/layers/support/LabelClass';
import { DHSREGEN } from '../configs/map.configs';

export function getAdmin1LabelingInfo() {
  const textSymbol = new TextSymbol({
    color: 'black',
    haloSize: 0.75,
    haloColor: 'white',
    font: {
      size: 14,
      family: 'Arial',
    },
  });

  const labelClass = new LabelClass({
    labelExpressionInfo: {
      expression: `$feature['${DHSREGEN}']`, // Use a field in your data for labeling (e.g., NAME field)
    },
    symbol: textSymbol,
  });

  return labelClass;
}

export function getAdmin2LabelingInfo() {
  const textSymbol = new TextSymbol({
    color: 'black',
    haloSize: 0.75,
    haloColor: 'white',
    font: {
      size: 8,
      family: 'Arial',
    },
  });

  const labelClass = new LabelClass({
    labelExpressionInfo: {
      expression: `$feature['ADM2_NAME']`, // Use a field in your data for labeling (e.g., NAME field)
    },
    symbol: textSymbol,
  });

  return labelClass;
}
